import { render, staticRenderFns } from "./ArticleDetailTab.vue?vue&type=template&id=772a2b00"
import script from "./ArticleDetailTab.vue?vue&type=script&lang=js"
export * from "./ArticleDetailTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports